import $ from 'jquery';

export default {
  init() {
    $('li.service_1 figure').fadeIn();
    $('.services-list li:not(.service-category)').mouseenter(function () {
      if ($(this).data('state') !== true) {
        $('.service-image').fadeOut();
        $('.services-list li').data('state', false);
        $(this).data('state', true).find('figure').fadeIn();
      }
    });
  },
};
